import { SKILLS } from "../../../../common/constants.ts";
import i18n from "../util/i18n.ts";
import { MobileTooltip } from "./MobileTooltip.tsx";

// Look up at render time. The previous Object.fromEntries+i18n.t wrapper at
// module top returned the English defaults because initI18n hadn't run when
// this module first evaluates — see feedback-i18n-lazy.md.
const getSkillName = (k: string): string =>
	i18n.t(`skills.${k}`, { ns: "ui", defaultValue: SKILLS[k] ?? k });

const getSkillLabel = (k: string): string =>
	i18n.t(`skillsShort.${k}`, { ns: "ui", defaultValue: k });

export type SkillsHost =
	| "player-profile"
	| "draft-history-draft"
	| "draft-history-current"
	| "draft-history-peak"
	| "player-ratings"
	| "player-name-labels";

export const SkillsBlock = ({
	className,
	host,
	skills,
}: {
	className?: string;
	host: SkillsHost;
	skills?: string[];
}) => {
	if (skills === undefined) {
		return null;
	}

	return (
		<span
			className={className}
			data-skills-count={skills.length}
			data-skills-host={host}
		>
			{skills.map((skill) => (
				<MobileTooltip key={skill} title={getSkillName(skill)}>
					<span className="skill" data-skill-code={skill}>
						{getSkillLabel(skill)}
					</span>
				</MobileTooltip>
			))}
		</span>
	);
};
